import React, { useReducer } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/login';
import Home from './components/mainComponents/home';
import LandingPage from './components/landingPage';
// import MainWrapper from './layouts/MainWrapper';
import { RootContext } from './context/RootContext';
import rootReducer from './reducers/rootReducer';
import PrivateRoute from './layouts/PrivateRoute';

import NotificationHandler from "./notificationHandler";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const initalState = {
    auth: {
      isLoggedIn: false,
      user: null
    },
  };


  const [state, dispatch] = useReducer(rootReducer(initalState), initalState);

  return (
    <RootContext.Provider value={{ ...state, dispatch }}>
      <Router>
      <NotificationHandler /> {/* Always running */}
      <ToastContainer />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/home/*"
            element={
              <PrivateRoute>
                <Home path='/home'/>
              </PrivateRoute>
            }
          />
          <Route 
            path="/landingPage" 
            element={
              <PrivateRoute>
                <LandingPage />
              </PrivateRoute>
            } 
          />
          <Route
            path="/home/*"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />

        </Routes>
      </Router>
    </RootContext.Provider>
  );
}

export default App;
